document.addEventListener('DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('[data-table-modal]');

    if (!blocks.length) return;

    const getPageSections = function (block) {
        const content = block.closest('.regular-page__content, .article-body') || document.querySelector('.regular-page__content, .article-body, main');
        if (!content) return [];

        return Array.from(content.children).filter(function (element) {
            return element !== block && !element.matches('[data-table-modal]') && element.offsetParent !== null;
        });
    };

    const lockBody = function (isLocked) {
        document.documentElement.classList.toggle('has-table-modal-open', isLocked);
        document.body.classList.toggle('has-table-modal-open', isLocked);
    };

    blocks.forEach(function (block) {
        const trigger = block.querySelector('.block-table-modal__trigger');
        const overlay = block.querySelector('.block-table-modal__overlay');
        const closeButtons = block.querySelectorAll('[data-table-modal-close]');
        const contentWrap = block.querySelector('.block-table-modal__content-wrap');
        const scrollbar = block.querySelector('.block-table-modal__scrollbar');
        const targetIndex = Math.max(parseInt(block.dataset.targetSection || '1', 10), 1) - 1;
        const target = getPageSections(block)[targetIndex];

        if (!trigger || !overlay || !target) return;

        const openModal = function () {
            block.classList.add('block-table-modal--is-open');
            trigger.setAttribute('aria-expanded', 'true');
            overlay.setAttribute('aria-hidden', 'false');
            lockBody(true);
        };

        const closeModal = function () {
            block.classList.remove('block-table-modal--is-open');
            trigger.setAttribute('aria-expanded', 'false');
            overlay.setAttribute('aria-hidden', 'true');
            lockBody(false);
            trigger.focus();
        };

        const updatePosition = function () {
            const rect = target.getBoundingClientRect();
            const targetTop = rect.top + window.scrollY;
            const targetBottom = targetTop + target.offsetHeight;
            const attachOffset = -120;
            const activationPoint = window.innerHeight * 0.85;
            const shouldActivate = rect.top <= activationPoint;
            const shouldAttach = window.scrollY + window.innerHeight >= targetBottom + attachOffset + trigger.offsetHeight;

            block.classList.toggle('block-table-modal--is-active', shouldActivate || shouldAttach);
            block.classList.toggle('block-table-modal--is-attached', shouldAttach);
            trigger.disabled = !(shouldActivate || shouldAttach);

            if (shouldAttach) {
                trigger.style.top = targetBottom + attachOffset + 'px';
            } else {
                trigger.style.top = '';
            }
        };

        const updateScrollbar = function () {
            if (!contentWrap || !scrollbar) return;

            const maxScroll = contentWrap.scrollWidth - contentWrap.clientWidth;

            if (maxScroll <= 0) {
                scrollbar.style.setProperty('--table-scrollbar-width', '0px');
                scrollbar.style.setProperty('--table-scrollbar-left', '0px');
                return;
            }

            const trackWidth = scrollbar.clientWidth;
            const thumbWidth = Math.max((contentWrap.clientWidth / contentWrap.scrollWidth) * trackWidth, 36);
            const maxThumbLeft = trackWidth - thumbWidth;
            const thumbLeft = (contentWrap.scrollLeft / maxScroll) * maxThumbLeft;

            scrollbar.style.setProperty('--table-scrollbar-width', thumbWidth + 'px');
            scrollbar.style.setProperty('--table-scrollbar-left', thumbLeft + 'px');
        };

        trigger.disabled = true;
        trigger.addEventListener('click', function () {
            if (trigger.disabled) return;
            openModal();
            updateScrollbar();
        });

        closeButtons.forEach(function (button) {
            button.addEventListener('click', closeModal);
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && block.classList.contains('block-table-modal--is-open')) {
                closeModal();
            }
        });

        updatePosition();
        updateScrollbar();
        if (contentWrap) {
            contentWrap.addEventListener('scroll', updateScrollbar, { passive: true });
        }
        window.addEventListener('scroll', updatePosition, { passive: true });
        window.addEventListener('resize', function () {
            updatePosition();
            updateScrollbar();
        });
    });
});
